const fibonacciCode: string = `program fibonacci💩

🚀 🔢 fibonacci(🔢 n) {
  🤔(n 🙌 0) {
    🤲 0💩
  }💩
  🤔 (n 🙌 1) {
    🤲 1💩
  }
  ❌{
    🤲 fibonacci(n-1) + fibonacci(n-2)💩
 }💩
}

main() {
  var 🔢 i ⬅️ 1💩
  🖨(🔤Fibonacci up to 10🔤)💩
  🔂 10 {
    🖨(fibonacci(i))💩
    i ⬅️ i+1💩
  }
}`;
export default fibonacciCode;
